import { render, staticRenderFns } from "./dataindex.vue?vue&type=template&id=898b733e&scoped=true&"
import script from "./dataindex.vue?vue&type=script&lang=js&"
export * from "./dataindex.vue?vue&type=script&lang=js&"
import style0 from "./dataindex.vue?vue&type=style&index=0&id=898b733e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898b733e",
  null
  
)

export default component.exports